<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2022-12-27 11:49:36
 * @LastEditors: PF
 * @LastEditTime: 2023-08-08 13:50:14
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学期">
              <el-select disabled v-model="ruleForm.xqid" placeholder="学期" @change="xveqichaxvn(1)" style="width: 220px;" filterable>
                <el-option v-for="(item) in allXq" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在班级" prop="bjid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select disabled @change="xveqichaxvn(2)" v-model="ruleForm.bjid" placeholder="所在班级" style="width:220px" filterable>
                <el-option v-for="(item) in banjilist" :key="item.id" :label="item.xzbmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="考试科目" prop="kmid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select disabled @change="xveqichaxvn(3)" v-model="ruleForm.kmid" placeholder="考试科目" style="width:220px" filterable>
                <el-option v-for="(item) in kaoshikemu" :key="item.kmid" :label="item.kmmc" :value="item.kmid" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学号" prop="xh" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input disabled v-model="ruleForm.xh" @blur="xvesheng" placeholder="学号" style="max-width:220px" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分数" prop="fs" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.fs" placeholder="分数" style="max-width:220px" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学生姓名:">
              {{xsxx.xm}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级:">
              {{xsxx.xzbmc}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学号:">
              {{xsxx.xh}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import {
  submitEditForm,
  closeWindow,
  loadData,
  loadSelect
} from '@/api/common.js'
const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const allXq = ref() // 学期
const banjilist = ref() // 考试任务
const kaoshikemu = ref() // 考试科目
const xsxx = ref({
  xm: '',
  xzbmc: '',
  xh: ''
}) // 学生信息
// 方法
const xs = ref()
const xvesheng = () => {
  if (ruleForm.value.xh) {
    const info = { xh: ruleForm.value.xh, bjid: ruleForm.value.bjid }
    loadSelect({
      url: '/api/v2/jiaowu/chengjikaoshirenwu/xuehao',
      data: xs,
      parms: info,
      loadSuccess: function (res) {
        xsxx.value = {
          xm: res.data.xm,
          xzbmc: res.data.xzbmc,
          xh: res.data.xh
        }
      }
    })
  }
}
const xveqichaxvn = (e) => {
  if (e === 1) {
    ruleForm.value.ksrwid = ''
    ruleForm.value.kmid = ''
    getbanji()
  } else if (e === 2) {
    ruleForm.value.kmid = ''
    getkaoshikemu()
  }
}
// 班级
const getbanji = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/list',
    data: banjilist,
    parms: { xqid: ruleForm.value.xqid },
    order: 'xqmc',
    sort: 'asc',
    loadSuccess: function (res) {
      getkaoshikemu()
    }
  })
}
// 考试科目
const getkaoshikemu = () => {
  loadSelect({
    url: '/api/v2/jiaowu/chengjixueshengpingshichengji/banjikemu',
    data: kaoshikemu,
    parms: { xqid: ruleForm.value.xqid, bjid: ruleForm.value.bjid },
    order: 'kmmc',
    sort: 'asc'
  })
}

// 提交
const submit = async () => {
  submitEditForm({
    url: '/api/v2/jiaowu/chengjixueshengpingshichengji/chengji',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openEdit', emits, true)
    }
  })
}

watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: allXq,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              ruleForm.value.xqid = element.id
              getbanji()
            }
          })
        }
      })
      loadData({
        url: '/api/v2/jiaowu/chengjixueshengpingshichengji/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          xsxx.value = {
            xm: res.data.xsxm,
            xzbmc: res.data.xsbjmc,
            xh: res.data.xsxh
          }
          ruleForm.value.bjid = res.data.xsszbjid
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
